import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { UpdatePaymentApiAccountsListRequestModel, UpdatePaymentApiAccountsListResponseModel } from "@/features/accounts/payment/api/services/update-accounts-list-model";

export class UpdatePaymentApiAccountsListApi {
  /**
   * MoneyLook 口座更新API(LookAPI版)
   */
  public updatePaymentApiAccountsList = async (
    param: UpdatePaymentApiAccountsListRequestModel
  ): Promise<UpdatePaymentApiAccountsListResponseModel> => {
    const path = `/api/paymentaccounts/api/updateaccounts`;
    const res = await ApiClient.instance.post<UpdatePaymentApiAccountsListResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
